/**
 * In the delivery tab, the user has to chose between those
 * 3 options for the delivery address
 */
export enum DeliveryAddressTypeChoice {
    NEW_ADDRESS = "new_address",
    MY_LOCATION = "my_location",
    LAST_USED = "last_used",
    FIXED_ADDRESS = "fixed_address",
}